import React from 'react';
import { useReactiveVar } from '@apollo/client';
import FeaturedAlbumArt from '../../Shared/FeaturedAlbumArt';
import { albumArtDefault } from '../../../utils/helpers';
import useGetCollection from '../../../hooks/Collection/useGetCollection';
import { organisationLoggedInAs } from '../../../utils/reactiveVars';

const SearchCollectionArt = ({ id }) => {
  const organisationRef = useReactiveVar(organisationLoggedInAs)?.id || null;

  const { data } = useGetCollection(id, organisationRef, {
    loadSilently: true,
  });

  return (
    <>
      {data ? (
        <div className="resources-favourites__card__thumbnail__show">
          <FeaturedAlbumArt songs={data?.collection?.songs} />
        </div>
      ) : (
        <img
          src={albumArtDefault}
          alt="collection"
          className="resources-favourites__card__thumbnail__show"
        />
      )}
    </>
  );
};

export default SearchCollectionArt;
